'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalNotchLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalNotchLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalNotchLine: React.FC<Omit<IVerticalLineProps, 'skin'>> = props => {
  return <VerticalLine {...props} skin={VerticalNotchLineSkin} />;
};

export default VerticalNotchLine;
